import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    return {
        dialog: {
            minHeight: '400px',
            padding: 0,
            backgroundColor: theme.palette.background.paper,
        },
        header: {
            position: 'relative',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.background.default,
            '& .MuiTabs-indicator': {
                display: 'none',
            },
        },
        content: {
            padding: 0,
            overflow: 'overlay',
        },
        navButton: {
            transition: '.5s',
            padding: theme.spacing(2.25, 3.5),
            textTransform: 'none',
            color: `${theme.palette.type === Theme.Light ? '#777' : '#eee'}`,
            position: 'relative',
            fontSize: '16px',
            fontWeight: 700,
            '&:hover': {
                backgroundColor: `${theme.palette.type === Theme.Light ? '#f3f3f3' : '#353535'}`,
                color: `${theme.palette.type === Theme.Light ? '#333' : '#fff'}`,
            },
        },
        navButtonActive: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.primary.main,
            },
        },
        close: {
            marginRight: theme.spacing(1.5),
            height: 'fit-content',
        },
    };
});
